export const ADD_MESSAGE = "ADD_MESSAGE";
export const USER_TYPING = "USER_TYPING";
export const ASSISTANT_RESPONDING = "ASSISTANT_RESPONDING";
export const ADD_BULK_MESSAGE = "ADD_BULK_MESSAGE";
export const DELETE_ALL_MESSAGES = "DELETE_ALL_MESSAGES";
export const SET_HAS_INITIALIZED_MESSAGES = "SET_HAS_INITIALIZED_MESSAGES";
export const ADD_SELECTED_VALUE = "ADD_SELECTED_VALUE";
export const REMOVE_SELECTED_VALUE = "REMOVE_SELECTED_VALUE";
export const REMOVE_ALL_SELECTED_VALUE = "REMOVE_ALL_SELECTED_VALUE";
export const DELETE_MESSAGES_KEEPING_INITIAL =
    "DELETE_MESSAGES_KEEPING_INITIAL";
export const APPEND_TO_MESSAGE = "APPEND_TO_MESSAGE";
export const APPEND_TO_LAST_MESSAGE = "APPEND_TO_LAST_MESSAGE";
export const ADD_ERROR_MESSAGE = "ADD_ERROR_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const REMOVE_MESSAGE_BY_ID = "REMOVE_MESSAGE_BY_ID";
export const TOGGLE_CHAT_VISIBILITY = "TOGGLE_CHAT_VISIBILITY";
export const ADD_REPORT = "ADD_REPORT";
export const SET_ACTIVE_REPORT = "SET_ACTIVE_REPORT";
export const LOAD_REPORTS = "LOAD_REPORTS";
export const SET_CHAT_EXPANDED = "SET_CHAT_EXPANDED";
export const SET_TASK_STATUS_MESSAGE = "SET_TASK_STATUS_MESSAGE"
export const SHOW_CITATIONS = "SHOW_CITATIONS";
export const HIDE_CITATIONS = "HIDE_CITATIONS";
export const CLEAR_CITATIONS = "CLEAR_CITATIONS";
export const SET_HISTORY_METADATA = "SET_HISTORY_METADATA";
export const CLEAR_HISTORY_METADATA = "CLEAR_HISTORY_METADATA";
export const SET_ACTIVE_REQUEST = "SET_ACTIVE_REQUEST";
export const SET_ACTIVE_REQUEST_HAS_CONTENT = "SET_ACTIVE_REQUEST_HAS_CONTENT";
export const CLEAR_ACTIVE_REQUEST = "CLEAR_ACTIVE_REQUEST";
export const UPDATE_REPORT_MESSAGE = "UPDATE_REPORT_MESSAGE";
export const ENTER_SECTION_EDIT_MODE = "ENTER_SECTION_EDIT_MODE";
export const EXIT_SECTION_EDIT_MODE = "EXIT_SECTION_EDIT_MODE";
export const REVISE_SECTION_DRAFT_START = "REVISE_SECTION_DRAFT_START";
export const REVISE_SECTION_DRAFT_SUCCESS = "REVISE_SECTION_DRAFT_SUCCESS";
export const REVISE_SECTION_DRAFT_FAILURE = "REVISE_SECTION_DRAFT_FAILURE";
export const SAVE_SECTION_EDIT_START = "SAVE_SECTION_EDIT_START";
export const SAVE_SECTION_EDIT_SUCCESS = "SAVE_SECTION_EDIT_SUCCESS";
export const SAVE_SECTION_EDIT_FAILURE = "SAVE_SECTION_EDIT_FAILURE";
export const DELETE_REPORT_SECTION = "DELETE_REPORT_SECTION";
export const REORDER_REPORT_SECTIONS = "REORDER_REPORT_SECTIONS";
export const MOVE_SECTION_UP = "MOVE_SECTION_UP";
export const MOVE_SECTION_DOWN = "MOVE_SECTION_DOWN";
export const ADD_NEW_SECTION_INPUT = "ADD_NEW_SECTION_INPUT";
export const REMOVE_NEW_SECTION_INPUT = "REMOVE_NEW_SECTION_INPUT";
export const ADD_NEW_SECTION_START = "ADD_NEW_SECTION_START";
export const ADD_NEW_SECTION_SUCCESS = "ADD_NEW_SECTION_SUCCESS";
export const ADD_NEW_SECTION_FAILURE = "ADD_NEW_SECTION_FAILURE";
export const SAVE_NEW_SECTION_START = "SAVE_NEW_SECTION_START";
export const SAVE_NEW_SECTION_SUCCESS = "SAVE_NEW_SECTION_SUCCESS";
export const SAVE_NEW_SECTION_FAILURE = "SAVE_NEW_SECTION_FAILURE";
export const SET_LAST_MESSAGE_TRACE_ID = "SET_LAST_MESSAGE_TRACE_ID";
export const SET_FOLLOWUP_SUGGESTIONS = "SET_FOLLOWUP_SUGGESTIONS";
export const CLEAR_FOLLOWUP_SUGGESTIONS = "CLEAR_FOLLOWUP_SUGGESTIONS";
export const SET_WELCOME_SUGGESTIONS = "SET_WELCOME_SUGGESTIONS";
export const CLEAR_WELCOME_SUGGESTIONS = "CLEAR_WELCOME_SUGGESTIONS";
export const ATTACH_QUERY_PARAMS = "ATTACH_QUERY_PARAMS";

// ── Conversations (contract 1.4) ──────────────────────────────────────────
// A turn is one exchange: a user message and everything Lou produced for it.
// Every message of a turn carries the same turn_id, which is what the reply
// is keyed on — position in the message list stops being a stable target the
// moment the same conversation is open in two places.
export const TURN_STARTED = "TURN_STARTED";
export const TURN_RECONCILED = "TURN_RECONCILED";
export const TURN_SEND_FAILED = "TURN_SEND_FAILED";
export const TURN_STATUS = "TURN_STATUS";
export const TURN_THINKING = "TURN_THINKING";
export const MESSAGE_DELTA = "MESSAGE_DELTA";
export const MESSAGE_COMPLETE = "MESSAGE_COMPLETE";
export const TURN_FAILED = "TURN_FAILED";
export const CONFIRMATION_REQUIRED = "CONFIRMATION_REQUIRED";
export const LOAD_TRANSCRIPT = "LOAD_TRANSCRIPT";
export const SET_ACTIVE_CONVERSATION = "SET_ACTIVE_CONVERSATION";
export const SET_CONVERSATIONS = "SET_CONVERSATIONS";
export const CONVERSATION_UPSERTED = "CONVERSATION_UPSERTED";
export const CONVERSATION_REMOVED = "CONVERSATION_REMOVED";
export const SET_CONVERSATIONS_LOADING = "SET_CONVERSATIONS_LOADING";
export const TURN_STOPPED = "TURN_STOPPED";
export const SET_TURN_FEEDBACK = "SET_TURN_FEEDBACK";
export const SET_CONTEXT_PANEL_TURN = "SET_CONTEXT_PANEL_TURN";
